var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgPCoolingChillerSw = function SvgPCoolingChillerSw(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "0 0 684.2 480.2",
    xmlSpace: "preserve",
    enableBackground: "new 0 0 684.2 480.2"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "52.1,385.1 116.1,385.1 116.1,397.1 40.1,397.1",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "47.1,390.1 116.1,390.1 116.1,392.1 45.1,392.1",
    fill: "#437FA3"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "49.1,388.1 116.1,388.1 116.1,387.1 50.1,387.1",
    fill: "#787878"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "43.1,394.1 116.1,394.1 116.1,395.1 42.1,395.1",
    fill: "#787878"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "52.1,385.1 40.1,397.1 40.1,62.1 52.1,62.1",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "42.1,395.1 42.1,62.1 43.1,62.1 43.1,394.1",
    fill: "#787878"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "47.1,390.1 45.1,392.1 45.1,62.1 47.1,62.1",
    fill: "#437FA3"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "50.1,387.1 49.1,388.1 49.1,62.1 50.1,62.1",
    fill: "#787878"
  }))));
};
export default SvgPCoolingChillerSw;